import '../Register/register.css';
import { z } from 'zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as api from '../../../services/api';
import { zodResolver } from '@hookform/resolvers/zod';
import Pagination from '../../Pricing/Pagination';
import { AxiosResponse } from 'axios';
import { toast } from 'react-toastify';
import { DefaultMessage } from '../../../utils/defaultMessages';

const schemaFilter = z.object({
  prod: z.string().min(1, 'Selecione um produto.'),
  manuf: z.string(),
  model: z.string(),
  page: z.string(),
});

interface ApiResponse {
  content: {
    pages: number;
    results: any[];
  };
}

type FilterSchema = z.infer<typeof schemaFilter>;

const FilterField = () => {
  const [dataTable, setDataTable] = useState<Array<any>>();

  const [manufs, setManufs] = useState<any[]>([]);
  const [models, setModels] = useState<any[]>([]);
  const [prodNum, setProdNum] = useState<number>();
  const [totalPages, setTotalPages] = useState<number>(1);
  const [currentPage, setCurrentPage] = useState(1);

  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm<FilterSchema>({
    mode: 'all',
    resolver: zodResolver(schemaFilter),
    defaultValues: {
      prod: '',
      manuf: '',
      model: '',
      page: '1',
    },
  });

  const filter = async (data: FilterSchema) => {
    const { prod, ...rest }: Record<string, unknown> = data;

    const cleanedObj = Object.fromEntries(
      Object.entries(rest).filter(
        ([_, value]) => typeof value === 'string' && value !== '',
      ),
    ) as Record<string, string>;

    cleanedObj.page = data.page;

    try {
      let urlParams = new URLSearchParams(cleanedObj);
      urlParams.set('page', String(cleanedObj.page ?? 1));
      urlParams.set('page_size', '10');

      if (cleanedObj.manuf) {
        urlParams.set('mounter_code', cleanedObj.manuf);
        urlParams.delete('manuf');
      }

      const res = (await api.get(
        `table/list/model/${prod}/?${urlParams.toString()}`,
      )) as AxiosResponse<ApiResponse>;

      setDataTable(res.data.content.results);
      setTotalPages(Number(res.data.content.pages));
    } catch (error) {
      toast.error(DefaultMessage.ERROR, {
        position: toast.POSITION.TOP_RIGHT,
      });
    }
  };

  const handlePageChange = (newPage: string) => {
    setCurrentPage(Number(newPage));
    filter({ ...getValues(), page: newPage });
  };

  const getProd = async (prodNum: string) => {
    setProdNum(Number(prodNum));
    const resp: any = await api.get(
      `table/search/mounter/${prodNum}/`,
    );
    await getManuf(resp.data.content);
    return;
  };

  const getManuf = async (manufs: any) => {
    setManufs(manufs);
    return;
  };

  const getModel = async (manufCode: string) => {
    await api
      .get(`table/search/codes/${prodNum}/${manufCode}/`)
      .then((response: any) => {
        setModels(response.data.content);
      });
  };

  const machines = [
    { id: '4', name: 'CARROCERIAS' },
    { id: '6', name: 'COLHEITADEIRA' },
    // { id: "2", name: "Helicóptero" },
    { id: '3', name: 'SEMIRREBOQUE' },
    { id: '1', name: 'TRATOR' },
  ];

  return (
    <div className="bg-white h-[100%] w-full rounded-lg shadow-sm px-8 py-4">
      <form
        className="w-full flex flex-col md:flex-row gap-1 md:gap-4"
        onSubmit={handleSubmit(filter)}
      >
        <div className="flex flex-col w-full md:w-[25%]">
          <label htmlFor="produto" className="labelRegister">PRODUTO</label>
          <select
            className="cadInput w-[100%!] text-start "
            id="produto"
            {...register('prod')}
            onChange={(e) => {
              getProd(e.target.value);
            }}
          >
            <option value="" disabled selected>
              PRODUTO
            </option>
            {machines.map((machine) => (
              <option
                className="text-[#6B7280] font-semibold"
                key={machine.id}
                value={machine.id}
              >
                {machine.name}
              </option>
            ))}
          </select>
          {errors.prod && (
            <span className="text-red-400 text-[12px] font-normal">
              {errors.prod.message}
            </span>
          )}
        </div>
        <div className="flex flex-col w-full md:w-[25%]">
          <label htmlFor='fabricante' className="labelRegister text-start">FABRICANTE</label>
          <select
            data-testid="select-fabricante"
            className="cadInput w-full"
            id="fabricante"
            {...register('manuf')}
            onChange={(e) => {
              getModel(e.target.value);
            }}
          >
            <option value="" selected hidden>
              FABRICANTE
            </option>
            {manufs?.map((item: any) => {
              return <option value={item.mounter_code}>{item.mounter}</option>;
            })}
          </select>
          {errors.manuf && (
            <span className="text-red-400 text-[12px] font-normal">
              {errors.manuf.message}
            </span>
          )}
        </div>
        <div className="flex flex-col w-full md:w-[25%]">
          <label className="labelRegister">MODELO</label>
          <select className="cadInput  wfull]" id="" {...register('model')}>
            <option value="" selected hidden>
              MODELO
            </option>
            {models?.map((item: any) => {
              return (
                <option value={item.model_code}>{item.description}</option>
              );
            })}
          </select>
          {errors.model && (
            <span className="text-red-400 text-[12px] font-normal">
              {errors.model.message}
            </span>
          )}
        </div>
        <button
          className="bg-[#00AEEF] text-white h-10 rounded-full w-full md:w-[25%] mt-4"
          type="submit"
        >
          FILTRAR
        </button>
      </form>
      <div className="divTable border-2 border-gray-300 h-max mt-4 rounded-lg mb-4">
        <table className="min-w-full border-2 border-gray-300 rounded-lg tableFilter">
          <thead className="rounded-full">
            <tr className="border-2 w-full rounded-full">
              <th className="min-w-[150px]">COD. FABRICANTE</th>
              <th className="min-w-[150px]">FABRICANTE</th>
              <th className="min-w-[150px]">COD. MODELO</th>
              <th className="min-w-[150px]">EIXOS</th>
              <th className="min-w-[150px]">DESCRIÇÃO</th>
              <th className="min-w-[150px]">TAMANHO</th>
              <th className="min-w-[150px]">UNIDADE</th>
            </tr>
          </thead>
          <tbody>
            {dataTable?.map((obj) => {
              return (
                <tr>
                  <td>{obj.mounter_code}</td>
                  <td>{obj.mounter}</td>
                  <td>{obj.model_code}</td>
                  <td>{obj.axis === null ? '0' : obj.axis}</td>
                  <td>{obj.description}</td>
                  <td>{obj.size}</td>
                  <td>{obj.unit === null ? '0' : obj.unit}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default FilterField;
